import { useMemo } from "react"
import { useSelector } from "react-redux"
import { buildOptionsMaps } from "src/utils/buildOptionsMaps"

const useUsersByUnits = params => {
  const fnFilter = params?.filter
  const fnMap = params?.map
  const leadItems = params?.leadItems || []
  const trailItems = params?.trailItems || []
  const conjunto = useSelector(state => state.complex.complex)
  const users = useSelector(state => state.complex.users)
  const units = useSelector(state => state.complex.units)

  const usersByUnit = useMemo(() => {
    if (!conjunto?.id) {
      return []
    }

    const userResidente = users.filter(item => item.Roles?.residente === true)
    let listOfUsers = []

    units.forEach(unit => {
      if (unit.IdPropietario) {
        const data = userResidente.find(snap => snap.id === unit.IdPropietario)
        if (data) {
          listOfUsers.push({
            ...data,
            EsPropietario: true,
            id: `${unit.id}/${data.id}`,
            idUser: data.id,
            idUnit: unit.id,
            Casa: unit.Numero,
            Alicuota: unit.Alicuota,
            fullname: `${data.Nombre} ${data.Apellido}`,
            label: `${unit.Numero} -> ${data?.Nombre} ${data?.Apellido}`,
            tipo: unit.Tipo || "",
            grupos: data.Grupos || [],
          })
        }
      }
      if (unit.IdInquilino) {
        const data = userResidente.find(snap => snap.id === unit.IdInquilino)
        if (data) {
          listOfUsers.push({
            ...data,
            EsPropietario: false,
            id: `${unit.id}/${data.id}`,
            idUser: data.id,
            idUnit: unit.id,
            Casa: unit.Numero,
            Alicuota: unit.Alicuota,
            fullname: `${data.Nombre} ${data.Apellido}`,
            label: `${unit.Numero} -> ${data?.Nombre} ${data?.Apellido}`,
            tipo: unit.Tipo || "",
            grupos: data.Grupos || [],
          })
        }
      }
    })

    listOfUsers.sort((a, b) =>
      a.Casa?.toString().localeCompare(b.Casa?.toString(), "en", {
        numeric: true,
      })
    )

    if (fnFilter) {
      listOfUsers = listOfUsers.filter(fnFilter)
    }
    if (fnMap) {
      listOfUsers = listOfUsers.map(fnMap)
    }
    if (leadItems.length > 0) {
      listOfUsers = leadItems.concat(listOfUsers)
    }
    if (trailItems.length > 0) {
      listOfUsers = listOfUsers.concat(trailItems)
    }

    return listOfUsers
  }, [conjunto?.id, fnFilter, fnMap, leadItems, trailItems, units, users])

  const { optionsById, optionsByUserId } = useMemo(
    () => buildOptionsMaps(usersByUnit),
    [usersByUnit]
  )

  return { usersByUnit, optionsById, optionsByUserId, conjunto }
}

export default useUsersByUnits
